<template>
  <div class="content">
    <component :is="dynamicComponent"></component>
    <!-- masonry -->
    <div class="masonry_wrapper">
      <div class="masonry">
        <div class="masonry_item">
          <div class="masonry__content masonry__static">
            <h3 class="masonry__title">Welcome!</h3>
            <p class="masonry__text">
              This page is a showcase of my current journey in designing,
              developing and deploying cloud solution.
            </p>
            <p class="masonry__text">
              Simply pick one of the project flash cards, to see, play and get
              some insight on how it was designed.
            </p>
            <p class="masonry__text">
              <span v-if="!validToken">
                <!-- prettier-ignore -->
                Please
                <a v-bind:href="signin_link">sign in</a>, to see more projects.
              </span>
            </p>
          </div>
        </div>
        <div class="masonry_item" v-on:click="onClickCognito">
          <div class="masonry__content masonry__content--small" id="mansory_cognito">
            <h3 class="masonry__title">Cognito</h3>
            <p class="masonry__text">
              view user account information, required sign in.
              <Cognito></Cognito>
            </p>
          </div>
        </div>
        <div class="masonry_item">
          <div class="masonry__content masonry__content--medium"></div>
        </div>
        <div class="masonry_item" v-on:click="onClickGetJokes">
          <div class="masonry__content masonry__content--small" id="mansory_jokes">
            <h3 class="masonry__title">Jokes</h3>
            <p class="masonry__text">
              Display random jokes from public REST API service.
              <Jokes></Jokes>
            </p>
          </div>
        </div>
        <div class="masonry_item">
          <div class="masonry__content masonry__content--medium" id="mansory_flex_subnetting">
            <h3 class="masonry__title"><a href="https://chrome.google.com/webstore/detail/flex-subnetting-subnet-ca/eddiehgpgoegchpkdimdbckecfcienel?hl=en"  target=”_blank”>Flex Subnetting</a></h3>
            <p class="masonry__text">
              A Chrome Extension network tool to calculate complex IPv4 subnets.
            </p>            
          </div>
        </div>
        <div class="masonry_item">
          <div class="masonry__content"></div>
        </div>
        <div class="masonry_item">
          <div class="masonry__content masonry__content--large" id="mansory_special_buys">
            <h3 class="masonry__title"><a href="https://www.amazon.com.au/dp/B09KXH79WZ" target="_blank">Special Buys</a></h3>
            <p class="masonry__text">
              <img class="icon" src="@/assets/images/sb-logo-118.png"/>
              An Alexa Skill to browse Aldi's Catalog, available in Australia Only.
            </p>            
          </div>
        </div>
        <div class="masonry_item">
          <div class="masonry__content masonry__content--medium"></div>
        </div>
        <div class="masonry_item">
          <div class="masonry__content masonry__content--small"></div>
        </div>
        <div class="masonry_item">
          <div class="masonry__content"></div>
        </div>
        <div class="masonry_item">
          <div class="masonry__content masonry__content--medium"></div>
        </div>
      </div>
    </div>
    <!-- mansory end -->
  </div>
</template>
<script>
import Slider from "@/components/Slider.vue";
import Jokes from "@/components/Jokes.vue";
import Cognito from "@/components/Cognito.vue";

import { mapGetters } from "vuex";
import { SIGNIN_URL } from "../constants";
import eventBus from "../eventBus";

export default {
  name: "apps",
  components: {
    Slider,
    Jokes,
    Cognito
  },
  data: function() {
    return {
      dynamicComponent: "Slider",
      //activeComponent: "Slider",
      validToken: false,
      signin_link: SIGNIN_URL
    };
  },
  created() {
    //if token valid, display Secure Page
    this.validToken = this.$store.getters["cognito/getStatusToken"];
  },
  computed: {
    ...mapGetters(["cognito/getStatusToken", "cognito/getIdToken"])
  },
  methods: {
    onClickGetJokes: function() {
      this.dynamicComponent = "Slider";
      eventBus.$emit("JOKES_REQUEST", {});
    },
    onClickCognito: function() {
      this.dynamicComponent = "Slider";
      eventBus.$emit("TOKEN_DISPLAY_USERINFO", {});
    }
  }
};
</script>
<style>
.content {
  text-align: center;
  padding: 20px;
}

/*-- Mansory --*/
/* https://codepen.io/ramenhog/pen/dvZVda */
.masonry_wrapper {
  text-align: center;
  width: 100%;
  display: flex;
}
.masonry {
  background: #fff;
  -webkit-column-count: 1;
  column-count: 1;
  -webkit-column-gap: 0;
  column-gap: 0;
  counter-reset: item-counter;
  padding-top: 20px;
  max-width: 1300px;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.masonry_item {
  box-sizing: border-box;
  -webkit-column-break-inside: avoid;
  break-inside: avoid;
  padding: 10px;
  counter-increment: item-counter;
  color: #333;
}

.masonry__content {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 220px;
  background: currentColor;
  box-sizing: border-box;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2), 0 3px 8px 0 rgba(0, 0, 0, 0.19);
  background: #fff;
  font-size: 1em;
  text-align: left;
}
.masonry__content:hover {
  background: #eee;
}
.masonry__content:before {
  position: absolute;
  top: 0;
  left: 0;
  font-size: 13px;
  width: 2em;
  height: 2em;
  line-height: 2em;
  text-align: center;
  font-weight: bold;
  background-color: #eee;
  /*content: counter(item-counter);*/
}
.masonry__content:empty:after {
  content: "ಠ‿ಠ";
}

.masonry__content--small {
  height: 100px;
}
.masonry__content--small:empty:after {
  content: "♥◡♥";
}
.masonry__content--medium {
  height: 175px;
}
.masonry__content--medium:empty:after {
  content: "◔ᴗ◔";
}
.masonry__content--large {
  height: 280px;
}
.masonry__content--large:empty:after {
  content: "ಠ_๏";
}
.masonry__title {
  padding: 0.3em;
  margin: 0 1em 0.25em 1em;
  margin: 0;
}
.masonry__title a:link,
.masonry__title a:visited{
  color: #333;
  text-decoration: none;
}
.masonry__text {
  margin: 0 1em;
  text-align: center;
}
.masonry__static {
  justify-content: left;
  align-items: left;
  height: 280px;
  margin: 0.5em 1em;
  box-shadow: none;
}
.masonry__static .masonry__title {
  width: 100%;
  margin: 0;
  text-align: left;
}
.masonry__static .masonry__text {
  margin: 0.5em 0em;
  text-align: left;
}
.masonry__static:hover {
  background: #fff;
}
@media screen and (min-width: 400px) {
  .masonry {
    -webkit-column-count: 2;
    column-count: 2;
  }
  .masonry__title {
    font-size: 1.3em;
  }
  .masonry__text {
    font-size: 0.85em;
  }
}
@media screen and (min-width: 600px) {
  .masonry {
    -webkit-column-count: 3;
    column-count: 3;
  }
  .masonry__title {
    font-size: 1em;
  }
  .masonry__text {
    font-size: 0.85em;
  }
}
@media screen and (min-width: 900px) {
  .masonry {
    -webkit-column-count: 3;
    column-count: 3;
  }
  .masonry__title,
  .masonry__text {
    font-size: 1em;
  }
}
@media screen and (min-width: 1100px) {
  .masonry {
    -webkit-column-count: 4;
    column-count: 4;
  }
  .masonry__title,
  .masonry__text {
    font-size: 1em;
  }
}
/*-- end Mansory --*/
#mansory_cognito{
  background-color:rgb(64, 179, 169);
}
#mansory_jokes{
  background-color:rgb(123, 179, 123);
}

#mansory_jokes{
  background-color:rgb(123, 179, 123);
}
#mansory_special_buys{
  background-color: rgb(127, 88, 172);
  color: white;
}
#mansory_special_buys a:link,
#mansory_special_buys a:visited{
  color: white;
}

#mansory_special_buys img.icon {
  width: 3.5rem;
  float: left;
}
#mansory_flex_subnetting{
  background-color: rgb(216, 160, 57);
}
</style>
